/* eslint-disable */
/* eslint-disable react/prop-types */
/* eslint-disable quotes */
import React from 'react';

import { useMemo, useState } from 'react';
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
  MRT_GlobalFilterTextField,
  MRT_ToggleFiltersButton,
} from 'material-react-table';

//Material UI Imports
import {
  Box,
  Button,
  Dialog,
  ListItemIcon,
  MenuItem,
  Typography,
  lighten,
  Avatar,
  IconButton,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
} from '@mui/material';

//Icons Imports
import { Add, Edit, Delete, PersonAdd, CloudUpload, Delete as DeleteIcon, Person } from '@mui/icons-material';

import FormComponent from './MaterialReactTableModals/FormComponent';
import AgentFormComponent from './MaterialReactTableModals/AgentFormComponent';

const Material_React_Table = ({ 
  data = [], 
  columns = [], 
  onRowAdd, 
  onRowUpdate, 
  onRowDelete, 
  onAgentAdd,
  userInitialState 
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAgentModalOpen, setAgentModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); // 'add' or 'edit'
  const [selectedRow, setSelectedRow] = useState(null);
  const [agentSourceRow, setAgentSourceRow] = useState(null);

  const handleOpenModal = (type, rowData = null) => {
    setModalType(type);
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const handleOpenAgentModal = (rowData = null) => {
    setAgentSourceRow(rowData);
    setAgentModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRow(null);
  };

  const handleCloseAgentModal = () => {
    setAgentModalOpen(false);
    setAgentSourceRow(null);
  };

  const handleFormSubmit = (values) => {
    if (modalType === "add") {
      onRowAdd(values);
    } else if (modalType === "edit") {
      onRowUpdate(values);
    }
    handleCloseModal();
  };

  const handleAgentFormSubmit = (values) => {
    if (onAgentAdd) {
      onAgentAdd(values);
    }
    handleCloseAgentModal();
  };

  const table = useMaterialReactTable({
    columns: useMemo(() => columns, [columns]),
    data: useMemo(() => data, [data]),
    enableColumnFilterModes: true,
    enableColumnOrdering: true,  
    enableGrouping: true,
    enableEditing: false, 
    editingMode: 'row',
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: true,
    enableRowSelection: true,
    initialState: {
      ...{
        showColumnFilters: true,
        showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
      },
      ...userInitialState,
    },
    paginationDisplayMode: 'pages',
    positionToolbarAlertBanner: 'bottom',
    muiSearchTextFieldProps: {
      size: 'small',
      variant: 'outlined',
    },
    muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [10, 20, 30],
      shape: 'rounded',
      variant: 'outlined',
    },
    renderRowActionMenuItems: ({ row, closeMenu }) => [
      <MenuItem
        key="edit"
        onClick={() => {
          closeMenu();
          handleOpenModal("edit", row.original);
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Edit />
        </ListItemIcon>
        Update
      </MenuItem>,
      // <MenuItem
      //   key="add-agent"
      //   onClick={() => {
      //     closeMenu();
      //     handleOpenAgentModal(row.original);
      //   }}
      //   sx={{ m: 0 }}
      // >
      //   <ListItemIcon>
      //     <PersonAdd />
      //   </ListItemIcon>
      //   Add Agent
      // </MenuItem>,
      <MenuItem
        key="delete"
        onClick={() => {
          closeMenu();
          if (onRowDelete) onRowDelete(row.original);
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <Delete />
        </ListItemIcon>
        Delete Row
      </MenuItem>,
    ],
    renderTopToolbar: ({ table }) => {
      return (
        <Box
          sx={(theme) => ({
            backgroundColor: lighten(theme.palette.background.default, 0.05),
            display: 'flex',
            gap: '0.5rem',
            p: '8px',
            justifyContent: 'space-between',
          })}
        >
          <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <MRT_GlobalFilterTextField table={table} />
            <MRT_ToggleFiltersButton table={table} />
          </Box>
          <Box>
            <Box sx={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                color="info"
                onClick={() => handleOpenModal("add")}
                variant="contained"
                startIcon={<Add />}
              >
                Add User
              </Button>
              <Button
                color="success"
                onClick={() => handleOpenAgentModal()}
                variant="contained"
                startIcon={<PersonAdd />}
              >
                Add Agent
              </Button>
            </Box>
          </Box>
        </Box>
      );
    },
  });

  return (
    <>
      <MaterialReactTable table={table} />

      {/* Add/Edit User Modal */}
      <Dialog open={isModalOpen} onClose={handleCloseModal} fullWidth maxWidth="md">
        {isModalOpen && (
          <FormComponent
            modalType={modalType}
            onClose={handleCloseModal}
            onSubmit={handleFormSubmit}
            data={selectedRow}
            columns={columns}
          />
        )}
      </Dialog>

      {/* Add Agent Modal */}
      <Dialog open={isAgentModalOpen} onClose={handleCloseAgentModal} fullWidth maxWidth="lg">
        {isAgentModalOpen && (
          <AgentFormComponent
            onClose={handleCloseAgentModal}
            onSubmit={handleAgentFormSubmit}
            sourceData={agentSourceRow}
          />
        )}
      </Dialog>
    </>
  );
};

export default Material_React_Table;